'use strict';
angular.module('liveChatModule', [])
    .run(['liveChatService', liveChatService => {
        TRPCONFIG.Domain.LiveChat
        && TRPCONFIG.Domain.LiveChat.Enabled
        && liveChatService.initialise();
    }]);
